import { Component } from 'vue-property-decorator'

import { dateToDisplay } from '@/utils/dateTime'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import PoliciesList from '@/modules/Policy/scripts/policies-list'

@Component({})
export default class PoliciesListFromDashboard extends PoliciesList {
  async mounted () {
    this.onResize()
    await this.clearPage()
    this.getList()
  }
}
